import { bake_cookie,read_cookie } from 'sfcookies';
import { ADD_REMINDER,DEL_REMINDER,CLEAR_ALL_REMINDER } from '../constants';



const reminder = action =>{
    let {text,dueDate} = action;
    return {
        text,
        id: Math.floor(Math.random()*100),
        dueDate
    }
}

const delReminder = (id,state=[]) => {
    let resArr = state.filter(reminder=>reminder.id!==id)
    return resArr;
}

const reminders = (state=[],action) => {
    let reminders = null;
    state = read_cookie('reminders');
    switch (action.type) {
        case ADD_REMINDER:
            reminders = [...state, reminder(action)]
            //console.log('reminders as state after add',reminders);
            bake_cookie('reminders',reminders);
            return reminders;
        case DEL_REMINDER:
             reminders = delReminder(action.id,state);
             //console.log('reminders as state after del',reminders);
             bake_cookie('reminders',reminders);
             return reminders;
        case CLEAR_ALL_REMINDER:
             reminders = []
             bake_cookie('reminders',reminders);
             return reminders;
        
            
        default:
            return state;
    }
}
 
export default reminders;


// WEBPACK FOOTER //
// ./src/reducers/reminderReducer.js